import { render, staticRenderFns } from "./ProductModify.vue?vue&type=template&id=3d83284c&scoped=true&"
import script from "./ProductModify.vue?vue&type=script&lang=js&"
export * from "./ProductModify.vue?vue&type=script&lang=js&"
import style0 from "./ProductModify.vue?vue&type=style&index=0&id=3d83284c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d83284c",
  null
  
)

export default component.exports